<template>
  <div class="container">
    <div class="text-center">
      <img class="img-detail-subscription" :src="copy_subscription.product.url_image" alt="">
    </div>

    <div class="d-flex justify-content-center align-items-center subscription-detail color-blue">
      <h3 class="subscrition-name font-backward mr-2">
        {{ copy_subscription.product.name }}
      </h3>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            color="secondary"
            class="mt-5"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-arrow-up-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in products"
            :key="index"
            @click="changeProduct(item)"
          >
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

    </div>

    <div class="row">
      <div class="center-content-sm col-lg-2 col-md-2 col-sm-12 col-xs-12">
        <p class="h4 color-blue font-general-r mt-2">
          SABORES:
        </p>
      </div>
      <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
        <v-chip
          class="mr-2 mb-2"
          color="primary"
          v-for="(flavor, i) in copy_subscription.flavors"
          :key="i"
          close
          @click:close="removeFlavor(i)"
        >
          {{flavor.flavor_name}}
        </v-chip>
      </div>
      <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12">

      </div>
    </div>

    <div class="row mt-5" v-for="(item, index) in flavors" :key="index">
      <div
        v-for="(flavor, index) in item.flavors"
        :key="index"
        class="col-lg-3 col-md-4 col-xs-6 col-sm-6 col-6"
        style="padding-bottom: 0; padding-top: 0"
      >
        <p @click="selectFlavor(flavor, item.key_)" :class="`h5 ${ flavorSelected(flavor.id) ? 'color-primary' : 'color-blue' } font-general-r text-uppercase pointer`">
          {{ flavor.name }}
        </p>
      </div>
      <div class="col-lg-3 col-md-4 col-xs-6 col-sm-6 col-6">
        <p
          @click="selectFlavor(option_temporada, 'temporada')"
          :class="`h5 ${ flavorSelected(null) ? 'color-primary' : 'color-blue' } font-general-r text-uppercase pointer`"
        >
          SABOR DE TEMPORADA
        </p>
      </div>
    </div>

    <div class="text-right">
      <v-btn
        :loading="loading_btn_subscription"
        @click="changeSubscription()"
        elevation="0"
        color="primary"
        class="nv-btn nv-btn-large mt-5"
      >EDITAR</v-btn>
    </div>

    <v-snackbar
      v-model="open_message"
      color="accent"
      dark
      :top="top"
      :bottom="bottom"
    >
      {{ message }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click="open_message = false"
        >
          Ok
        </v-btn>
      </template>
    </v-snackbar>

    <PopupMessage
      ref="popupMessage"
      message="Tu suscripción ha sido modificada exitosamente"
    />

  </div>
</template>

<script>
import HomeService from '@/services/home.service'
import { currencyFormat } from '@/helpers'
import SubscriptionService from '@/services/subscription.service'

export default {
  props: ['copy_subscription'],
  data() {
    return {
      products: [],
      flavors: [],
      open_message: '',
      message: '',
      loading_btn_subscription: false,
      modal_success_edit: false,
      option_temporada: { id: 'temporada', flavor_id: 'temporada', name: 'SABOR DE TEMPORADA', remove: true, category_key: 'temporada' },
      top: false,
      bottom: false
    }
  },
  methods: {
    async changeSubscription() {
      try {

        if (this.copy_subscription.flavors_ids.length != this.copy_subscription.product.quantity_products) {
          return this.$swal(
            `Para ${this.copy_subscription.product.name} debes seleccionar ${this.copy_subscription.product.quantity_products} ${this.copy_subscription.product.quantity_products > 1 ? 'sabores' : 'sabor' }`, '', 'warning')
        }
        this.loading_btn_subscription = true
        const { data:res } = await SubscriptionService.updateSubscription(this.copy_subscription)
        if (res.success) {
          this.$refs.popupMessage.openDialog()
          this.$emit('successEdit')
        } else {
          this.$swal(res.error, '', 'warning')
        }
      } catch (error) {
        this.$swal('En estos momentos no podemos procesar tu solicitud','','warning')
      }
      this.loading_btn_subscription = false
    },
    changeProduct(item) {
      this.copy_subscription.product = JSON.parse(JSON.stringify(item))
    },
    removeFlavor(index) {
      this.copy_subscription.flavors.splice(index, 1)
      this.copy_subscription.flavors_ids.splice(index, 1)
    },
    async getProducts() {
      const { data:res } = await HomeService.getSubscriptionProducts()
      this.products = res.products
      this.flavors = res.flavors
    },
    selectFlavor(flavor, key_category_flavor) {

      if (flavor.id == 'temporada') {
        let count_flavor_temporada = this.copy_subscription.flavors.filter(i => i.flavor_name == 'SABOR DE TEMPORADA')
        console.log(count_flavor_temporada.length)
        if (count_flavor_temporada.length == 4) {
          this.$swal(
            `Solo puedes elegir 4 sabores de temporada`,
            '',
            'warning'
          )
          return false
        }
      }

      if (this.copy_subscription.flavors.length < (this.copy_subscription.product.quantity_products)) {
        this.copy_subscription.flavors.push({
          id: flavor.id,
          flavor_id: flavor.id,
          flavor_name: flavor.name,
          category_key: key_category_flavor
        })
        this.copy_subscription.flavors_ids.push(flavor.id)
        //if (!this.copy_subscription.flavors_ids.includes(flavor.id)) {

        //}
      } else {
        this.message = `Para esta suscripción solo puedes elegir ${this.copy_subscription.product.quantity_products} ${this.copy_subscription.product.quantity_products > 1 ? 'sabores' : 'sabor'}`
        this.open_message = true
      }
    },
    flavorSelected(flavor_id) {
      if (flavor_id == 'temporada') return true
      if (this.copy_subscription.flavors_ids.includes(flavor_id)) {
        return true
      } else {
        return false
      }
    },
    currencyFormat(price) {
			return currencyFormat(price)
    }
  },
  mounted() {
    this.getProducts()
    let width = screen.width

    if (width <= 768) {
      this.top = true
      this.bottom = false
    }
  }
}
</script>

<style scoped>
  .v-chip.v-size--default {
    border-radius: 0px;
    text-transform: uppercase;
    font-weight: 500;
  }
</style>
